import * as React from "react";

import { nullElement } from "../../TypingUtils";

import emptyDocumentImage from "./emptyDocument.png";

interface ImgProps {
    src?: string;
    predefinedImage?: "emptyDocument";
}

export function Img(props: ImgProps): JSX.Element | null {
    if (props.src != undefined) {
        return <img src={props.src} />;
    }
    if (props.predefinedImage != undefined) {
        if (props.predefinedImage === "emptyDocument") {
            return <img src={emptyDocumentImage} />;
        } else {
            return nullElement;
        }
    }
    return nullElement;
}
